import { config } from '@shopee-user/platform';

import type {
  GetChangeEmailHelpLinkFunction,
  GetChangeEmailNativeVerificationLinkFunction,
  GetChangePasswordHelpLinkFunction,
  GetChangePasswordNativeVerificationLinkFunction,
} from '@shopee-user/business-customization-types';
import { SupportedLocale } from '../../constants/customerServicesUrl'; // to maintain single source of truth first until all URL constants is moved as util.

const CHANGE_EMAIL_HELP_LINK_MAP: Record<SupportedLocale, string> = {
  ID: 'https://help.shopee.co.id/portal/4/article/72212',
  MY:
    'https://help.shopee.com.my/portal/2/article/148715-[ShopeeFood-Rakan-Penghantar]-Panduan-Mengemaskini-Butiran-Akaun-Rakan-Penghantar?previousPage=secondary%20category',
  TH:
    'https://help.shopee.co.th/portal/2/article/146706-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%81%E0%B9%89%E0%B9%84%E0%B8%82%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%AA%E0%B9%88%E0%B8%A7%E0%B8%99%E0%B8%95%E0%B8%B1%E0%B8%A7%E0%B8%94%E0%B9%89%E0%B8%A7%E0%B8%A2%E0%B8%95%E0%B8%99%E0%B9%80%E0%B8%AD%E0%B8%87?previousPage=search%20recommendation%20bar',
  VN:
    'https://help.cs.shopeefood.vn/portal/104/article/71354-Thay-%C4%91%E1%BB%95i-%C4%91%E1%BB%8Ba-ch%E1%BB%89-email?previousPage=search%20recommendation%20bar',
  PH: '',
};

export const getChangeEmailHelpLink: GetChangeEmailHelpLinkFunction = () => {
  return CHANGE_EMAIL_HELP_LINK_MAP[config.LOCALE as SupportedLocale] || '';
};

const CHANGE_PASSWORD_HELP_LINK_MAP: Record<SupportedLocale, string> = {
  ID: 'https://help.shopee.co.id/portal/4/article/179618',
  MY: 'https://help.shopee.com.my/portal/4/article/180316',
  TH: '',
  VN: '',
  PH: '',
};

export const getChangePasswordHelpLink: GetChangePasswordHelpLinkFunction = () => {
  return CHANGE_PASSWORD_HELP_LINK_MAP[config.LOCALE as SupportedLocale] || '';
};

// Use country specific schemes to support one device having apps from multiple regions
const CHANGE_EMAIL_NATIVE_VERIFICATION_LINK_MAP: Record<
  SupportedLocale,
  string
> = {
  ID: 'foodyid://driver/n/driver/slc/change_email_slc',
  TH: 'foodyth://driver/n/driver/slc/change_email_slc',
  MY: 'foodymy://driver/n/driver/slc/change_email_slc',
  VN: 'foodyvn://driver/n/driver/slc/change_email_slc',
  PH: 'foodyph://driver/n/driver/slc/change_email_slc',
};

const CHANGE_PASSWORD_NATIVE_VERIFICATION_LINK_MAP: Record<
  SupportedLocale,
  string
> = {
  ID: 'foodyid://driver/n/driver/slc/change_password_slc',
  TH: '',
  MY: 'foodymy://driver/n/driver/slc/change_password_slc',
  VN: 'foodyvn://driver/n/driver/slc/change_password_slc',
  PH: 'foodyph://driver/n/driver/slc/change_password_slc',
};

export const getChangeEmailNativeVerificationLink: GetChangeEmailNativeVerificationLinkFunction = () => {
  return (
    CHANGE_EMAIL_NATIVE_VERIFICATION_LINK_MAP[
      config.LOCALE as SupportedLocale
    ] || ''
  );
};

export const getChangePasswordNativeVerificationLink: GetChangePasswordNativeVerificationLinkFunction = () => {
  return (
    CHANGE_PASSWORD_NATIVE_VERIFICATION_LINK_MAP[
      config.LOCALE as SupportedLocale
    ] || ''
  );
};
